import { render, staticRenderFns } from "./RegisterOnlineConfirm.vue?vue&type=template&id=6125b9ec&"
import script from "./RegisterOnlineConfirm.vue?vue&type=script&lang=js&"
export * from "./RegisterOnlineConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports